import { all, fork } from 'redux-saga/effects';

import usersSaga from 'actions/users'
import showcaseSaga from 'actions/showcase';


export default function* root() {
  yield all([
    fork(usersSaga),
    fork(showcaseSaga),
  ])
}